import * as _ from 'lodash'
import { Notify } from 'quasar'

let isLoadedMap = false;
export function loadGoogleMap() {
  return new Promise((resolve, reject) => {
    if (isLoadedMap) {
      resolve();
      return;
    }
    const importScript = (function (oHead) {
      function loadError(oError) {
        reject(oError);
        throw new URIError(
          `The script ${oError.target.src} is not accessible.`
        );
      }
      return function (sSrc, fOnload) {
        const oScript = document.createElement('script');
        oScript.type = 'text/javascript';
        oScript.onerror = loadError;
        if (fOnload) {
          oScript.onload = fOnload;
        }
        oHead.appendChild(oScript);
        oScript.src = sSrc;
      };
    }(document.head || document.getElementsByTagName('head')[0]));
    importScript(
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyARrFJ0XJMS2Hrjfay8Y_UwI7FPiMkfp_E&libraries=places&sensor=false',
      () => {
        isLoadedMap = true
        resolve();
      }
    );
  });
}

// 获取当前位置经纬度
export function curPos(defaultAddress) {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(pos => {
      const location = {
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
      };
      resolve(location);
    }, err => {
      if (!defaultAddress) return reject(err);
      resolve(defaultAddress);
    })
  })
}

// 从地址数据中过滤出地址参数
export function getSaveParam(data) {
  const r = {};

  _.forEach(data.address_components, item => {
    // 获取国家
    if (item.types[0] === 'country') {
      r.countryName = item.long_name;

      if (
        r.countryName.indexOf('印度') >= 0 ||
        r.countryName.indexOf('香港') >= 0
      ) {
        r.countryName = 'Indonesia';
      }
    }

    // 省
    if (item.types[0] === 'administrative_area_level_1') {
      r.stateProvinceName = item.long_name;
    }

    // 城市
    if (item.types[0] === 'administrative_area_level_2') {
      r.cityName = item.long_name;
    }

    // 地区
    if (item.types[0] === 'administrative_area_level_3') {
      r.districtName = item.long_name;
    }

    // 街道
    if (item.types[0] === 'administrative_area_level_3') {
      r.subDistrictName = item.long_name;
    }

    // 编号
    if (item.types[0] === 'postal_code') {
      r.postalCode = item.long_name;
    }
  });

  // 如果没有地址那么就用一级地址
  if (!r.cityName) {
    r.cityName = r.stateProvinceName;
    r.districtName = r.stateProvinceName;
    r.subDistrictName = r.stateProvinceName;
  }

  // 地址3
  r.address3 = data.formatted_address;

  const { nickName, phone, email } = this.$store.state.Menu?.userInfo || {};
  // 昵称
  r.toName = nickName;

  // 电话
  r.phone = phone;

  // 邮箱
  r.email = email;

  const { geometry = {} } = data;
  // 纬度
  r.latitude = geometry.location.lat();
  // 经度
  r.longitude = geometry.location.lng();
  return r;
}


export const NoticeQueue = (time = 300) => _.debounce((message, options) => {
  Notify.create({
    message,
    ...options
  })
}, time)

export const notify = NoticeQueue(400);


export const jakartaLocation = {
  lat: -6.176373,
  lng: 106.829079
}
